(() => {
  'use strict';
  const root = document.getElementById('ritual-bar-intake');
  if (!root) return;
  const form = root.querySelector('[data-rb-intake-form]');
  const endDefault = root.querySelector('[data-rb-intake-end="default"]');
  const endReview = root.querySelector('[data-rb-intake-end="review"]');
  const identify = root.querySelector('[data-rb-intake-identify]');
  const identifyErr = root.querySelector('[data-rb-intake-identify-err]');
  const CLINICAL_KEYS = ['pregnant_or_nursing', 'accutane_recent', 'recent_skin_treatment', 'active_skin_condition', 'recent_injectables'];
  if (!form) return;

  let token = new URLSearchParams(window.location.search).get('t');
  let phone = null;

  // Valid token → straight to the form. No/expired token → ask for the phone
  // they booked with (never a dead end). Submit resolves via token or phone.
  if (token) { showForm(); } else { showIdentify(); }

  function showForm() {
    if (identify) identify.hidden = true;
    if (endDefault) endDefault.hidden = true;
    if (endReview) endReview.hidden = true;
    form.hidden = false;
  }

  let identifyWired = false;
  function showIdentify() {
    form.hidden = true;
    if (endDefault) endDefault.hidden = true;
    if (endReview) endReview.hidden = true;
    if (!identify) return;
    identify.hidden = false;
    if (identifyWired) return;
    identifyWired = true;
    const findBtn = identify.querySelector('[data-rb-intake-find]');
    const phoneInput = identify.querySelector('[data-rb-intake-phone]');
    if (!findBtn || !phoneInput) return;
    const go = () => {
      const digits = (phoneInput.value || '').replace(/[^0-9]/g, '');
      if (digits.length < 10) { phoneInput.focus(); return; }
      phone = phoneInput.value;
      if (identifyErr) identifyErr.hidden = true;
      showForm();
    };
    findBtn.addEventListener('click', go);
    phoneInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') go(); });
    setTimeout(() => phoneInput.focus(), 60);
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalLabel = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Saving…';
    try {
      const payload = collectPayload(form);
      if (phone && !token) payload.phone = phone;
      const qs = token ? ('?t=' + encodeURIComponent(token)) : '';
      const res = await fetch('/apps/booking/intake' + qs, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (res.status === 404) { showIdentify(); if (identifyErr) identifyErr.hidden = false; return; }
        if (res.status === 401) { showIdentify(); return; }
        throw new Error('intake_' + res.status);
      }
      const data = await res.json();
      form.hidden = true;
      const target = data.review_required === true ? endReview : endDefault;
      if (target) target.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error('[rb-intake] submit failed', err);
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
      alert('Something went wrong saving your intake. Try again in a moment.');
    }
  });

  function collectPayload(formEl) {
    const fd = new FormData(formEl);
    const payload = {};
    for (const k of CLINICAL_KEYS) payload[k] = fd.get(k) === 'yes';
    payload.notes = String(fd.get('notes') || '').trim();
    payload.ambient_preference = String(fd.get('ambient_preference') || 'quiet');
    payload.fragrance_sensitive = fd.get('fragrance_sensitive') === 'yes';
    payload.face_covering_comfort = fd.get('face_covering_comfort') === 'yes';
    payload.meditation_focus = String(fd.get('meditation_focus') || 'open');
    return payload;
  }
})();
